// src/theme/theme.ts
import { extendTheme } from '@chakra-ui/react'

export const theme = extendTheme({
  colors: {
    brand: {
      primary: "#521577",    // Fundo principal (loja/evento)
      secondary: "#ffffff",   // Branco
      dark: "#1A202C",        // Cor escura para textos
      gray100: "#F7FAFC",     
      gray200: "#E2E8F0",
      gray600: "#4A5568",
      gray700: "#2D3748",
      gray800: "#1A202C",
    },
  },
  fonts: {
    heading: "Poppins, sans-serif",
    body: "Poppins, sans-serif",
  },
});
